import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileLock"><Path d="M4 2H12V10H20V22H13V14H11.584C10.8124 12.2341 9.05032 11 7 11C5.87439 11 4.83566 11.3719 4 11.9996V2Z" fill="currentColor"/><Path d="M14 2.58579L19.4142 8H14V2.58579Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M11 16V22H3V16H4C4 14.3431 5.34315 13 7 13C8.65685 13 10 14.3431 10 16H11ZM8 16C8 15.4477 7.55228 15 7 15C6.44772 15 6 15.4477 6 16H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileLock;
